// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"84358cce","247":"1668ad88","453":"51b20bab","551":"cdb70d0c","627":"8694b67b","653":"b88944cd","834":"bacb0519","867":"7f417c43","923":"f2e2b642","938":"11fac05d"}[chunkId] + ".chunk.js";
};